

















import {Component, Vue, Watch} from 'vue-property-decorator';
import { pick } from 'lodash';

import DialogCreateFromTemplate from '@/components/dialogs/dialog-create-from-template.vue';
import NETWORK_LIST_IN_TILE_FORMAT from '@/views/reports/forms/affiliate_network/network-list-in-tile-format';
import AffiliateNetworkApi from '@/services/rest/bemob/affiliate-network';

@Component({
  components: {
    DialogCreateFromTemplate
  }
})
export default class TrafficSourceFromTemplate extends Vue {
  show: boolean = false;
  edit: boolean = true;
  activeItem: any = null;
  search: string = '';
  networkListInTileFormat: any = NETWORK_LIST_IN_TILE_FORMAT;
  templates = []
  affiliateNetworkApi: AffiliateNetworkApi = new AffiliateNetworkApi();

  get itemsOthersTile() {
    return this.templates.filter((item:any)=>{
      return this.networkListInTileFormat[item.name]
    }) || [];
  }

  get itemsOthers() {
    return this.templates.filter((item:any)=>!item.main && !this.networkListInTileFormat[item.name]) || [];
  }

  get itemsIntegrated() {
    return this.templates.filter((item:any)=>item.main) || [];
  }

  get itemPick() {
    return [
      'appendClickId',
      'clickIdPlaceholder',
      'payoutPlaceholder',
      'transactionIdPlaceholder',
      'statusPlaceholder',
      'clickIdParam',
      'postbackStatusConfirm',
      'postbackStatusNew',
      'postbackStatusDecline',
      'postbackStatusChargeback',
      'name',
      'main',
      'integrationType'
    ];
  }

  getItem(id: string) {
    let item = this.templates.find((e: any) => e.id === id);

    if(item) {
      item = {
        ...pick(item, this.itemPick),
        templateId: item.id,
        usePostbackStatuses: !!(item.postbackStatusConfirm || item.postbackStatusNew || item.postbackStatusDecline || item.postbackStatusChargeback)
      }
    }

    this.close()
    this.bus.emit('open-dialog', { name: 'CreateAffiliateNetworks', data: item })
  }

  close() {
    this.$emit('close');
  }

  mounted() {
    this.$store.commit('loading', true);

    this.affiliateNetworkApi.getTemplates().then((data) => {
      this.templates = data;
      this.show = true

      this.$store.commit('loading', false);
    })
  }

  clickItem(item: any) {
    this.activeItem = item
  }
}
